import { dialogTitleClasses } from '@mui/material/DialogTitle';
export default function Dialog(theme) {
    return {
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: theme.radius(1),
                    margin: theme.spacing(3),
                    maxHeight: `calc(100% - ${theme.spacing(6)})`
                }
            }
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(1, 3)
                }
            }
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(1, 3),
                    [`.${dialogTitleClasses.root} + &`]: {
                        paddingTop: theme.spacing(2)
                    }
                }
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    minHeight: theme.spacing(7.5),
                    variants: [
                        {
                            props: {
                                bgstyle: 'title'
                            },
                            style: {
                                backgroundColor: theme.palette.background[100],
                                borderBottom: `1px solid ${theme.palette.background[300]}`
                            }
                        },
                        {
                            props: {
                                bgstyle: 'no-title'
                            },
                            style: {
                                paddingBottom: 0,
                                minHeight: `40px`
                            }
                        }
                    ]
                }
            },
            defaultProps: {
                variant: 'h5'
            }
        }
    };
}
